import { render, staticRenderFns } from "./PaymentsBatchReport.vue?vue&type=template&id=545b881e"
import script from "./PaymentsBatchReport.vue?vue&type=script&lang=js"
export * from "./PaymentsBatchReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports